import { render, staticRenderFns } from "./WizardIndicator.vue?vue&type=template&id=bf29fef6&lang=pug"
import script from "./WizardIndicator.vue?vue&type=script&lang=js"
export * from "./WizardIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports